<template>
  <div>
    <div v-if="loading" class="text-muted py-4">
      {{ $t("LOADING") }}
    </div>
    <div v-else-if="error" class="text-warning py-4">
      {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.LOAD_ERROR_DETAIL") }}
    </div>
    <div v-else-if="payload">
      <b-row class="mb-3">
        <b-col md="6">
          <h6 class="text-muted mb-2">
            {{
              $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PROFILE_CUSTOMER")
            }}
          </h6>
          <p class="mb-1">
            <strong>{{ displayName }}</strong>
          </p>
          <p v-if="payload.customer.phone_number" class="mb-1">
            {{ payload.customer.phone_number }}
          </p>
          <p v-if="genderLabel" class="mb-1">
            เพศ: {{ genderLabel }}
          </p>
          <p v-if="payload.customer.line_user_id" class="small text-muted mb-0">
            LINE UID: {{ payload.customer.line_user_id }}
          </p>
        </b-col>
        <b-col md="6">
          <h6 class="text-muted mb-2">
            {{
              $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PROFILE_POINTS")
            }}
          </h6>
          <p class="h4 text-primary mb-0">
            {{ totalPoints }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <p class="small text-muted mb-0">
            {{
              $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.MEMBER_JOINED")
            }}
            {{ formatDate(payload.membership.created_at) }}
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignMemberProfileBody",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    payload: {
      type: Object,
      default: null
    }
  },
  computed: {
    displayName() {
      if (!this.payload || !this.payload.customer) {
        return "—";
      }
      const c = this.payload.customer;
      const n = `${c.first_name || ""} ${c.last_name || ""}`.trim();
      if (n) {
        return n;
      }
      return c.display_name || "—";
    },
    genderLabel() {
      if (!this.payload || !this.payload.customer) return null;
      const g = this.payload.customer.gender;
      const map = {
        male: "ชาย",
        female: "หญิง",
        other: "อื่นๆ",
        unspecified: "ไม่ระบุ"
      };
      return map[g] || g || null;
      },
    totalPoints() {
      if (!this.payload || !this.payload.points) {
        return 0;
      }
      const v = this.payload.points.total_point;
      return v != null ? v : 0;
    }
  },
  methods: {
    formatDate(v) {
      if (!v) {
        return "—";
      }
      try {
        return new Date(v).toLocaleString();
      } catch (e) {
        return v;
      }
    }
  }
};
</script>
